import {lazy, Suspense} from 'react'

import {APP_NAME} from '@sdox/utils/dom'

import type {PanelFragment} from '@sdox/api'

const EditorDrawer = lazy(() => import('./EditorDrawer'))
const EufeDrawer = lazy(() => import('./EufeDrawer'))

export interface NestedContentDrawerProps {
  isOpen: boolean
  onClose: () => void
  panel: PanelFragment
}

export const NestedContentDrawer = (props: NestedContentDrawerProps) => {
  if (APP_NAME === 'cufe') {
    return (
      <Suspense fallback={null}>
        <EditorDrawer {...props} />
      </Suspense>
    )
  }

  return (
    <Suspense fallback={null}>
      <EufeDrawer {...props} />
    </Suspense>
  )
}
